import { api } from "..";

import { PlayerCoupon } from "@/types/ApiResponses/Coupon";
import { QueryProps } from "@/types/Api";

interface Params {
  statusList?: string[];
  lang?: string;
}

export const getUserCouponsWithRelations = async (
  props: QueryProps<Params>
): Promise<PlayerCoupon[]> => {
  const res = await api.client.get(`/users-new/coupons`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
